import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { User } from './user';
import { LoginService } from '../login/login.service';

@Injectable()
export class AuthService {
  private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  
  redirectUrl: string;
  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }

  constructor(
    private router: Router,
    private service: LoginService,
  ) { }

  login(user: User) {
    if (user.userName !== '' && user.password !== '') {
      this.loggedIn.next(true);
      this.router.navigate(['/']);
    }
  }

  PTlogin(userName: string, pass: string, captcha: string) {
    return this.service.SVLogin(userName, pass, captcha);

  }

  logout() {
    this.loggedIn.next(false);
    this.router.navigate(['/Login']);
  }

}
